import React from 'react';
import { useFormContext } from 'react-hook-form';
import { CARD_BACKGROUND_TYPE, ImageDomain } from "config/CustomEnums";
import logoExample from '../../assets/images/level/logoExample.png';
import QrCodeExample from '../../assets/images/level/qrCodeExample.png';
import { getBackgroundImage } from './utils';
import './LevelPortrait.scss';

const getPortraitConfig = (
  isNormal,
  isApp,
  webAppIsMobile,
) => {
  if (isNormal) {
    return {
      containerClassName: "",
    };
  };
  if (isApp) {
    return {
      containerClassName: "level-portrait-app-container",
    };
  };
  if (webAppIsMobile) {
    return {
      containerClassName: "level-portrait-webapp-mobile-container",
    };
  };
  return {
    containerClassName: "level-portrait-webapp-desktop-container",
  };
}

const LevelPortrait = ({
  isNormal,
  isApp,
  webAppIsMobile,
}) => {
  const { watch } = useFormContext();

  const foregroundColorField = "displayForegroundElementColor";
  const backgroundTypeField = "membershipCardBackgroundType";
  const backgroundColorField = "displayMembershipCardBackgroundColor";
  const appBackgroundImageField = "cardPortraitBackgroundImageInApp";
  const webappBackgroundImageField = "cardPortraitBackgroundImageInWeb";

  const watchForegroundColor = watch(foregroundColorField);
  const watchBackgroundType = watch(backgroundTypeField);
  const watchBackgroundColor = watch(backgroundColorField);
  const watchAppBackgroundImage = watch(appBackgroundImageField);
  const watchWebappBackgroundImage = watch(webappBackgroundImageField);

  const useImage = watchBackgroundType === CARD_BACKGROUND_TYPE.image;
  const portraitConfig = getPortraitConfig(isNormal, isApp, webAppIsMobile);
  const backgroundImage = getBackgroundImage(
    watchAppBackgroundImage,
    watchWebappBackgroundImage,
    isNormal,
    isApp
  );

  return (
    <div className={`level-portrait-container ${portraitConfig.containerClassName}`}>
      <div className='level-portrait-image-container'>
        {
          useImage
            ? <img
              alt=""
              src={backgroundImage ? `${ImageDomain}${backgroundImage}` : ''}
              className={`level-portrait-image`}
            />
            : null
        }
      </div>
      <div
        className={`level-portrait-items`}
        style={{
          color: `#${watchForegroundColor}`,
          ...(
            useImage
              ? null
              : { background: `#${watchBackgroundColor}` }
          ),
        }}
      >
        <img className="level-portrait-logo" src={logoExample} alt="" />
        <span className="level-portrait-name title-small">
          Peter Chan
        </span>
        <span className="level-portrait-membership-id body-2">
          ID: 8201234567
        </span>
        <img className="level-portrait-qr-code" src={QrCodeExample} alt="" />
        <div className="level-portrait-points">
          <span className='title-large'>500</span>
          <span className='headline'>points</span>
        </div>
        <span className={`level-portrait-level-name subheading`}>
          Level Name
        </span>
      </div>
    </div>
  );
}

export default LevelPortrait;
